"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL PartnerService
 * The EMIL PartnerService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerRelationsApi = exports.PartnerRelationsApiFactory = exports.PartnerRelationsApiFp = exports.PartnerRelationsApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * PartnerRelationsApi - axios parameter creator
 * @export
 */
var PartnerRelationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This will create a relationship between two partners. For example a parent-child relationship, or a partnership agreement.  **Required Permissions**  \"partner-management.partners.create\"
         * @summary Create the partner relation
         * @param {CreatePartnerRelationRequestDtoRest} createPartnerRelationRequestDtoRest
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerRelation: function (createPartnerRelationRequestDtoRest, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createPartnerRelationRequestDtoRest' is not null or undefined
                            (0, common_1.assertParamExists)('createPartnerRelation', 'createPartnerRelationRequestDtoRest', createPartnerRelationRequestDtoRest);
                            localVarPath = "/partnerservice/v1/partners/relations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPartnerRelationRequestDtoRest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Permanently deletes the partner-relation. Supply the unique code that was returned when you created the partner-relation and this will delete it.  **Required Permissions**  \"partner-management.partners.delete\"
         * @summary Delete the partner-relation
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerRelation: function (id, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deletePartnerRelation', 'id', id);
                            localVarPath = "/partnerservice/v1/partners/relations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve a single partner relation identified by its id  **Required Permissions**  \"partner-management.partners.view\"
         * @summary Retrieve the partner relation
         * @param {number} id Id of the partner relation
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerRelation: function (id, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getPartnerRelation', 'id', id);
                            localVarPath = "/partnerservice/v1/partners/relations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve a single partner relation type identified with a slug - can be used to create partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary Retrieve the partner relation type
         * @param {string} slug Identifying slug of the partner relation type
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerRelationType: function (slug, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'slug' is not null or undefined
                            (0, common_1.assertParamExists)('getPartnerRelationType', 'slug', slug);
                            localVarPath = "/partnerservice/v1/partners/relations/types/{slug}"
                                .replace("{".concat("slug", "}"), encodeURIComponent(String(slug)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List all partner relation types - is used to create partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary List partner relation types
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {string} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1, your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, relationName, maxCardinality, inverseMaxCardinality, partnerName&lt;/i&gt;
         * @param {string} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, maxCardinality, inverseMaxCardinality, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.       Expanding resources can reduce the number of API calls required to accomplish a task.       Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;       &lt;br/&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, relationName, maxCardinality, inverseMaxCardinality, partnerName&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerRelationTypes: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/partnerservice/v1/partners/relations/types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * List all partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary List partner relations
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {string} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1, your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partner1Id, partner2Id, partnerRelationTypeSlug, partnerRelationTypeId&lt;/i&gt;
         * @param {string} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partnerRelationTypeId, startDate, endDate, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.       Expanding resources can reduce the number of API calls required to accomplish a task.       Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;       &lt;br/&gt;       &lt;i&gt;Allowed values: partner1, partner2, partnerRelationType&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partner1Id, partner2Id, partnerRelationTypeSlug, partnerRelationTypeId&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerRelations: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/partnerservice/v1/partners/relations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a partner relation identified by its id  **Required Permissions**  \"partner-management.partners.update\"
         * @summary Update the partner relation
         * @param {number} id Id of the partner relation
         * @param {UpdatePartnerRelationRequestDtoRest} updatePartnerRelationRequestDtoRest
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerRelation: function (id, updatePartnerRelationRequestDtoRest, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updatePartnerRelation', 'id', id);
                            // verify required parameter 'updatePartnerRelationRequestDtoRest' is not null or undefined
                            (0, common_1.assertParamExists)('updatePartnerRelation', 'updatePartnerRelationRequestDtoRest', updatePartnerRelationRequestDtoRest);
                            localVarPath = "/partnerservice/v1/partners/relations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePartnerRelationRequestDtoRest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PartnerRelationsApiAxiosParamCreator = PartnerRelationsApiAxiosParamCreator;
/**
 * PartnerRelationsApi - functional programming interface
 * @export
 */
var PartnerRelationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PartnerRelationsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This will create a relationship between two partners. For example a parent-child relationship, or a partnership agreement.  **Required Permissions**  \"partner-management.partners.create\"
         * @summary Create the partner relation
         * @param {CreatePartnerRelationRequestDtoRest} createPartnerRelationRequestDtoRest
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerRelation: function (createPartnerRelationRequestDtoRest, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPartnerRelation(createPartnerRelationRequestDtoRest, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Permanently deletes the partner-relation. Supply the unique code that was returned when you created the partner-relation and this will delete it.  **Required Permissions**  \"partner-management.partners.delete\"
         * @summary Delete the partner-relation
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerRelation: function (id, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePartnerRelation(id, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve a single partner relation identified by its id  **Required Permissions**  \"partner-management.partners.view\"
         * @summary Retrieve the partner relation
         * @param {number} id Id of the partner relation
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerRelation: function (id, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPartnerRelation(id, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve a single partner relation type identified with a slug - can be used to create partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary Retrieve the partner relation type
         * @param {string} slug Identifying slug of the partner relation type
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerRelationType: function (slug, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPartnerRelationType(slug, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List all partner relation types - is used to create partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary List partner relation types
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {string} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1, your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, relationName, maxCardinality, inverseMaxCardinality, partnerName&lt;/i&gt;
         * @param {string} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, maxCardinality, inverseMaxCardinality, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.       Expanding resources can reduce the number of API calls required to accomplish a task.       Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;       &lt;br/&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, relationName, maxCardinality, inverseMaxCardinality, partnerName&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerRelationTypes: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPartnerRelationTypes(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * List all partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary List partner relations
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {string} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1, your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partner1Id, partner2Id, partnerRelationTypeSlug, partnerRelationTypeId&lt;/i&gt;
         * @param {string} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partnerRelationTypeId, startDate, endDate, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.       Expanding resources can reduce the number of API calls required to accomplish a task.       Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;       &lt;br/&gt;       &lt;i&gt;Allowed values: partner1, partner2, partnerRelationType&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partner1Id, partner2Id, partnerRelationTypeSlug, partnerRelationTypeId&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerRelations: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listPartnerRelations(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a partner relation identified by its id  **Required Permissions**  \"partner-management.partners.update\"
         * @summary Update the partner relation
         * @param {number} id Id of the partner relation
         * @param {UpdatePartnerRelationRequestDtoRest} updatePartnerRelationRequestDtoRest
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerRelation: function (id, updatePartnerRelationRequestDtoRest, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePartnerRelation(id, updatePartnerRelationRequestDtoRest, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PartnerRelationsApiFp = PartnerRelationsApiFp;
/**
 * PartnerRelationsApi - factory interface
 * @export
 */
var PartnerRelationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PartnerRelationsApiFp)(configuration);
    return {
        /**
         * This will create a relationship between two partners. For example a parent-child relationship, or a partnership agreement.  **Required Permissions**  \"partner-management.partners.create\"
         * @summary Create the partner relation
         * @param {CreatePartnerRelationRequestDtoRest} createPartnerRelationRequestDtoRest
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerRelation: function (createPartnerRelationRequestDtoRest, authorization, options) {
            return localVarFp.createPartnerRelation(createPartnerRelationRequestDtoRest, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Permanently deletes the partner-relation. Supply the unique code that was returned when you created the partner-relation and this will delete it.  **Required Permissions**  \"partner-management.partners.delete\"
         * @summary Delete the partner-relation
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerRelation: function (id, authorization, options) {
            return localVarFp.deletePartnerRelation(id, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve a single partner relation identified by its id  **Required Permissions**  \"partner-management.partners.view\"
         * @summary Retrieve the partner relation
         * @param {number} id Id of the partner relation
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerRelation: function (id, authorization, options) {
            return localVarFp.getPartnerRelation(id, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve a single partner relation type identified with a slug - can be used to create partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary Retrieve the partner relation type
         * @param {string} slug Identifying slug of the partner relation type
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerRelationType: function (slug, authorization, options) {
            return localVarFp.getPartnerRelationType(slug, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List all partner relation types - is used to create partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary List partner relation types
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {string} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1, your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, relationName, maxCardinality, inverseMaxCardinality, partnerName&lt;/i&gt;
         * @param {string} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, maxCardinality, inverseMaxCardinality, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.       Expanding resources can reduce the number of API calls required to accomplish a task.       Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;       &lt;br/&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, slug, relationName, maxCardinality, inverseMaxCardinality, partnerName&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerRelationTypes: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listPartnerRelationTypes(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * List all partner relations  **Required Permissions**  \"partner-management.partners.view\"
         * @summary List partner relations
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {string} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1, your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {string} [filter] Filter the response by one or multiple fields.            In general, fetching filtered responses will conserve bandwidth and reduce response time.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partner1Id, partner2Id, partnerRelationTypeSlug, partnerRelationTypeId&lt;/i&gt;
         * @param {string} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {string} [order] Order allows you to specify the desired order of entities retrieved from the server by           ascending (ASC) or descending (DESC) order.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partnerRelationTypeId, startDate, endDate, createdAt, updatedAt&lt;/i&gt;
         * @param {string} [expand] Expand to fetch additional information about the list items.       Expanding resources can reduce the number of API calls required to accomplish a task.       Use with discretion as some expanded fields can drastically increase payload size.&lt;br/&gt;       &lt;br/&gt;       &lt;i&gt;Allowed values: partner1, partner2, partnerRelationType&lt;i&gt;
         * @param {string} [filters] Filters the response by one or multiple fields.            Advanced filter functionality allows you to perform more complex filtering operations.&lt;br/&gt;           &lt;br/&gt;           &lt;i&gt;Allowed values: id, partner1Id, partner2Id, partnerRelationTypeSlug, partnerRelationTypeId&lt;/i&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerRelations: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listPartnerRelations(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a partner relation identified by its id  **Required Permissions**  \"partner-management.partners.update\"
         * @summary Update the partner relation
         * @param {number} id Id of the partner relation
         * @param {UpdatePartnerRelationRequestDtoRest} updatePartnerRelationRequestDtoRest
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerRelation: function (id, updatePartnerRelationRequestDtoRest, authorization, options) {
            return localVarFp.updatePartnerRelation(id, updatePartnerRelationRequestDtoRest, authorization, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PartnerRelationsApiFactory = PartnerRelationsApiFactory;
/**
 * PartnerRelationsApi - object-oriented interface
 * @export
 * @class PartnerRelationsApi
 * @extends {BaseAPI}
 */
var PartnerRelationsApi = /** @class */ (function (_super) {
    __extends(PartnerRelationsApi, _super);
    function PartnerRelationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This will create a relationship between two partners. For example a parent-child relationship, or a partnership agreement.  **Required Permissions**  \"partner-management.partners.create\"
     * @summary Create the partner relation
     * @param {PartnerRelationsApiCreatePartnerRelationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerRelationsApi
     */
    PartnerRelationsApi.prototype.createPartnerRelation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerRelationsApiFp)(this.configuration).createPartnerRelation(requestParameters.createPartnerRelationRequestDtoRest, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Permanently deletes the partner-relation. Supply the unique code that was returned when you created the partner-relation and this will delete it.  **Required Permissions**  \"partner-management.partners.delete\"
     * @summary Delete the partner-relation
     * @param {PartnerRelationsApiDeletePartnerRelationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerRelationsApi
     */
    PartnerRelationsApi.prototype.deletePartnerRelation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerRelationsApiFp)(this.configuration).deletePartnerRelation(requestParameters.id, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve a single partner relation identified by its id  **Required Permissions**  \"partner-management.partners.view\"
     * @summary Retrieve the partner relation
     * @param {PartnerRelationsApiGetPartnerRelationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerRelationsApi
     */
    PartnerRelationsApi.prototype.getPartnerRelation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerRelationsApiFp)(this.configuration).getPartnerRelation(requestParameters.id, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve a single partner relation type identified with a slug - can be used to create partner relations  **Required Permissions**  \"partner-management.partners.view\"
     * @summary Retrieve the partner relation type
     * @param {PartnerRelationsApiGetPartnerRelationTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerRelationsApi
     */
    PartnerRelationsApi.prototype.getPartnerRelationType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerRelationsApiFp)(this.configuration).getPartnerRelationType(requestParameters.slug, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List all partner relation types - is used to create partner relations  **Required Permissions**  \"partner-management.partners.view\"
     * @summary List partner relation types
     * @param {PartnerRelationsApiListPartnerRelationTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerRelationsApi
     */
    PartnerRelationsApi.prototype.listPartnerRelationTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PartnerRelationsApiFp)(this.configuration).listPartnerRelationTypes(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * List all partner relations  **Required Permissions**  \"partner-management.partners.view\"
     * @summary List partner relations
     * @param {PartnerRelationsApiListPartnerRelationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerRelationsApi
     */
    PartnerRelationsApi.prototype.listPartnerRelations = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PartnerRelationsApiFp)(this.configuration).listPartnerRelations(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a partner relation identified by its id  **Required Permissions**  \"partner-management.partners.update\"
     * @summary Update the partner relation
     * @param {PartnerRelationsApiUpdatePartnerRelationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerRelationsApi
     */
    PartnerRelationsApi.prototype.updatePartnerRelation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PartnerRelationsApiFp)(this.configuration).updatePartnerRelation(requestParameters.id, requestParameters.updatePartnerRelationRequestDtoRest, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PartnerRelationsApi;
}(base_1.BaseAPI));
exports.PartnerRelationsApi = PartnerRelationsApi;
